import React, { PureComponent } from 'react';

import {
  Wrapper,
  Title,
  Text,
  ImageContainer
} from '../components/ui';

import Image from '../../../../containers/assets/grading-engagement-score.jpg';

class EngagementScore extends PureComponent {
  render() {
    return (
      <Wrapper>
        <Title>Engagement Score</Title>
        <Text><p>The engagement score is a score students receive for reading the case study, customer analysis, and team reports. If they read the case study,  customer analysis (each round), and team reports (each round), then they’ll receive 100% overall engagement score. If they read partially then they’ll receive a partial score.</p></Text>
        <Text>
          <p><strong>Note 1:</strong> Engagement score is the weighted average score of the case study, customer analysis, and team reports engagements.  This model cannot be modified at this time.</p>
        </Text>
        <ImageContainer>
          <img src={Image} alt="Engagement Score" />
        </ImageContainer>
        <Text>
          <p><strong>Note 2:</strong> The system tracks each page read based on the length of time the student stays on the page.  The length of time is 10 seconds.</p>
        </Text>
      </Wrapper>
    );
  }

}

export default EngagementScore;



// WEBPACK FOOTER //
// ./src/instructor/components/grading/pages/engagement-score.js